const DEVICE_CODE = 'AUTH/DEVICE_CODE';

export default function deviceCodeAction (deviceCode: string, userCode: string, verificationUri: string, verificationUriComplete:string, expiresIn: number, interval:number = 5) {
  return {
    type: DEVICE_CODE,
    payload: { 
        deviceCode: deviceCode,
        userCode: userCode,
        verificationUri: verificationUri,
        verificationUriComplete: verificationUriComplete,
        expiresIn: expiresIn,
        interval: interval
     }
  };
}

export { DEVICE_CODE };